import { DataRibbon } from '../../Components/DataRibbon/DataRibbon';
import './about.css';
import school from './school.jpg';

export const About = () => {
  return (
    <>
      <section className="about">
        <div className='about_wrap'>
          <h1 className='page_title'>About the school</h1>
          <div className='about_content'>
            <div className='about_content_left'>
              <strong>Government High School, Gangapur</strong> is a government school situated in the Gangapur, District Hathras, Uttar Pradesh. It is affiliated Uttar Pradesh Madhyamik Siksha Parishad.
              <div className="location_details">
                <div className="location_title">Nearest major locations:</div>
                <div className='location_item'>
                  <i className="fa-solid fa-location-dot"></i>
                  22 km from Sikandra Rao
                </div>
                <div className='location_item'>
                  <i className="fa-solid fa-location-dot"></i>
                  29 km from Hathras
                </div>
              </div>
            </div>
            <div className='about_content_right'>
              <img src={school} alt='school' />
            </div>
          </div>
        </div>
        <DataRibbon />
        <h1 className='section_title'>Directions</h1>
        <div className='google_map'>
          <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28297.688778660922!2d78.2567519!3d27.5559583!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39748d2a23db18d9%3A0xcd431befd633b368!2sGovt%20High%20School%20Gangapur!5e0!3m2!1sen!2sin!4v1653393853294!5m2!1sen!2sin" width="90%" height="500" allowFullScreen={false} loading="eager"
            style={{ border: "0" }}
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </section>
    </>
  )
}
